import { authReducers } from './auth/auth.reducer';
import { appReducers } from './app/app.reducer';
import { userReducers } from './user/user.reducer';
import { tradeAccountReducers } from './trade/trade.account';
import { refreshReducers } from './app/refresh.reducer';
import { watchlistReducers } from './watchlist/watchlist.reducer'

const rootReducers = {
  app: appReducers,
  auth: authReducers,
  user: userReducers,
  trade: tradeAccountReducers,
  refresh: refreshReducers,
  watchlist: watchlistReducers
}

export default rootReducers
